<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
    <div class="container header-wrapper">
      <span class="fa fa-bars" (click)="openSideMenu()"></span>
      <img src="assets/images/logo.png" />
      <span *ngIf="user.isLoggedIn" class="fa fa-search" (click)="onProjectSearchLaunch()"></span>
      <span class="phone-number">
        <i class="fa fa-phone" aria-hidden="true"></i>
        <a class="mobile-only" href="tel:18667728878">1-866-772-8878</a>
      </span>
      <div *ngIf="!user.isLoggedIn" class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse">
        <span class="menu-item" (click)="onRegister()">Register</span>
        <span class="menu-item" (click)="onLogin()">Login</span>
      </div>
      <div *ngIf="user.isLoggedIn" class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse">
        <span class="menu-item" (click)="onLogout()">Logout</span>
        <span class="menu-item divider">|</span>
        <span class="menu-item name">Hi, {{user.firstName}}</span>
      </div>
    </div>
  </nav>
</header>

<div class="side-menu" [class.open]="sideMenuOpen">
  <div class="side-menu-overlay"  (click)="closeSideMenu()"></div>
  <div class="side-menu-content" (click)="contenBodyClick($event)">
    <span class="close" (click)="closeSideMenu()">x</span>
                
    <ng-container *ngIf="user.isLoggedIn; else elseBlock" >
      <span class="side-menu-name">Hi, {{user.firstName}}</span>  
      <span class="side-menu-item">Search For Quote</span>
    <span class="side-menu-item" (click)="onProjectSearchLaunch()">Search for Project</span>
    <span class="side-menu-item" (click)="onLogout()">Logout</span>
     </ng-container>
      
      <ng-template #elseBlock>
        <span class="side-menu-name">Guest User</span>      
        <span class="side-menu-item">Search For Quote</span>
        <span class="side-menu-item" (click)="onRegister()">Register</span>
        <span class="side-menu-item" (click)="onLogin()">Login</span>
      </ng-template>

      <div class="bottom-side-menu">
        <span class="phone-number">
          <i class="fa fa-phone" aria-hidden="true"></i>
          <a class="mobile-only" href="tel:18667728878">1-866-772-8878</a>
        </span>
      </div>

  </div>
</div>

<div class="container">
  <main role="main">
    <router-outlet></router-outlet>
  </main>
</div>

<footer class="border-top footer text-muted">
  <div class="container">
    <div class="logo-section">
      <div class="address-section">
        <img src="assets/images/footer-log.png" />
        <span>21751 Schmeman Ave</span>
        <span>Warren, MI 48089</span>
      </div>
      <div class="phone-numbers">
        <span>Toll Free:<a class="mobile-only" href="tel:18667728878">866-772-8878</a></span>
        <span>Phone:<a class="mobile-only" href="tel:5867728878">586-772-8878</a></span>
        <span>Fax: 586-772-6466</span>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div>@{{currentYear}} State Building Products All Rights Reserved.</div>
  </div>
</footer>